// Rating bar — animated horizontal bar with 0-10 score.
export default function RatingBar({ label, score, testId }) {
  const pct = Math.max(0, Math.min(100, (Number(score || 0) / 10) * 100));
  const scoreStr = Number(score || 0).toFixed(1);
  return (
    <div className="rating-row" data-testid={testId}>
      <div className="label-cell">{label}</div>
      <div className="bar"><div className="bar-fill" style={{ "--w": `${pct}%` }} /></div>
      <div className="score-cell">{scoreStr}</div>
    </div>
  );
}
